module.exports = __webpack_public_path__ + "static/media/payment.26cbd187.svg";